/**
 * useThemeScheme — tracks the app's current color scheme by observing the
 * `scheme` attribute on `<html>`, so components can react to theme changes
 * made elsewhere (e.g. a theme toggle) without their own MutationObserver.
 *
 * Returns `currentScheme` ('light' | 'dark') and the derived `isDarkMode` flag.
 */
import { ref, onMounted, computed } from 'vue';

/** Returns the reactive current color scheme and whether it is dark mode. */
export function useThemeScheme() {
  const currentScheme = ref(document.documentElement.getAttribute('scheme') || 'light');

  onMounted(() => {
    const observer = new MutationObserver(() => {
      currentScheme.value = document.documentElement.getAttribute('scheme') || 'light';
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['scheme'],
    });
  });

  const isDarkMode = computed(() => currentScheme.value === 'dark');

  return { currentScheme, isDarkMode };
}
